import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const searchRequest = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/requestApproval/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const processRequest = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/requestApproval/process`,
    data,
  );
  return response;
};

export const getRoute = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/requestApproval/getAllRoutes`,
    );
    console.log(`Route: `, response.data);
    return response.data.map((item) => ({
      key: item.id,
      text: item.route,
      value: item.id,
    }));
  } catch (e) {
    console.error(e);
  }
};
